export const SUCCESS_VISIBLE = "SUCCESS_VISIBLE";
export const SUCCESS_INVISIBLE = "SUCCESS_INVISIBLE";
